import { logIn, emailLogin, passwordLogin, checkLoginType } from '../../../api';
import { onRequest } from '../..';
import { getUrlParam, PropertyType, ActionsType } from '../../../common';

type LoginType = (rs: PropertyType) => void;

const loginSubmit = async (state: PropertyType, login: LoginType) => {
	const { email, password } = state;
	const res = await logIn({ email, password });

	login(res);
};

const emailSubmit = async (state: PropertyType, payload: PropertyType) => {
	const { loginType } = payload;
	const { email } = state;
	const success = await emailLogin(email, loginType);

	return { errors: [], success };
};

const onCheckLoginType = async () => {
	const type = await checkLoginType();

	return { loginType: type };
};

const passwordSubmit = async (state: PropertyType, payload: PropertyType) => {
	const { login, loginType } = payload;
	const { password } = state;
	const token = getUrlParam('token');
	const email = getUrlParam('email');
	const res = await passwordLogin({ token, email, password }, loginType);

	login(res);
};

export const actions: ActionsType = {
	EMAIL: (state, payload) => ({ email: payload }),
	EMAIL_INVALID: (state, payload) => ({ emailInvalid: payload }),
	PASS: (state, payload) => ({ password: payload }),
	ERROR: (state, payload) => ({ errors: payload }),
	SUCCESS: (state, payload) => ({ success: payload }),
	LOGIN_SUBMIT: (state, payload) => onRequest(() => loginSubmit(state, payload)),
	EMAIL_SUBMIT: (state, payload) => onRequest(() => emailSubmit(state, payload)),
	PASS_SUBMIT: (state, payload) => onRequest(() => passwordSubmit(state, payload)),
	LOGIN_TYPE: () => () => onCheckLoginType(),
	MESSAGE_INVALIDATE: () => ({ errors: [], success: '' }),
};
